import { COMMON_STATE_KEYS } from '../../global-store/subjects/common/initial-state';

export const ABSTRACT_CLASSNAME = '.c-article-abstract';
export const HERO_CLASSNAME = '.c-intro';
export const SCROLL_EVENT_THROTTLE_TIME = 500;

export const PLAYER_CARD_CLOSE_HOOK = '.j-player-card__close';
export const CAROUSEL_ELEMENT_HOOK = '.j-player-carousel-element';
export const PLAYER_WITH_CAROUSEL_ID = '#j-player-with-carousel';
export const CAROUSEL_SECTION_CONTAINER_ID = '#video-with-carousel-section-container';
export const CAROUSEL_CONTAINER_HOOK = '.j-player-carousel-container';
export const CAROUSEL_HOOK = '.j-player-carousel';
export const ASPECT_RATIO_CLASS_NAME = 'o-aspect-ratio--16-9';
export const GLOBAL_NAV_HOOK = '.j-global-nav';
export const PLAYER_POSTER_CLASS_NAME = '.j-player-carousel .skyplayer-preview-container';
export const PLAYER_POSTER_CLASS_NAME_FALL_BACK = '.j-player-carousel #j-player-with-carousel_jwplayer';
export const LOCAL_NAV_HOOK = '.j-local-nav';
export const UTILITY_VIDEO_STICKY_CLASS_NAME = 'u-video-sticky-local-open';
export const TOLERANCE_SPACE = 250;
export const VIDEO_CAROUSEL_STATUS_KEY = COMMON_STATE_KEYS.VIDEO_CAROUSEL_STATUS;

export const VIDEO_CAROUSEL_SET_VALUE = Object.freeze({
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  ALL: 'all',
});

// the element that goes into the sticky position
export const $videoCarouselSticky = document.querySelector(CAROUSEL_ELEMENT_HOOK);
export const $videoCarouselStickyContainer = document.querySelector(CAROUSEL_SECTION_CONTAINER_ID);
export const $videoCarouselStickyHeader = $videoCarouselSticky?.querySelector(PLAYER_CARD_CLOSE_HOOK);
export const $videoElemenCarouseltStickyContainerSpace = document.querySelector(CAROUSEL_CONTAINER_HOOK);
export const $localNav = document.querySelector(LOCAL_NAV_HOOK);

export const stickyCarouselActive = $videoCarouselSticky?.dataset?.stickycarouselactive === 'true';
export const firstVideoSticky = $videoCarouselSticky?.dataset?.firstvideosticky === 'true';
export const stickyDeviceMode = $videoCarouselSticky?.dataset?.stickydevicemode;
